import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Auth } from '../contexts/AuthContext';

const PrivateRoute = ({ element }) => {
    const { state, loading } = Auth();
    const location = useLocation();

    if (loading || !state.isAuthenticated || !state.token) {
        // Preserve the intended destination (including ?post= deep-link params)
        // so the login page can redirect back after successful authentication.
        return <Navigate to="/sign-in" state={{ from: location }} replace />;
    }

    if (state.requiresOrganizationSetup && location.pathname !== "/organization-setup") {
        return <Navigate to="/organization-setup" replace />;
    }

    return element;
};

export default PrivateRoute;
